import { CoreIcon } from '../core-icon';
import arrowRightSVG from '../../../src/images/icons/arrow-right.svg';

export const ArrowRightIcon = props => {
  return <CoreIcon src={arrowRightSVG} {...props} />;
};
